import React from 'react';
import { HyperText } from '../components/HyperText';
import { DifferentiatorsTimeline } from '../components/DifferentiatorsTimeline';
import { StrategicFeatures } from '../components/StrategicFeatures';
import { Grid } from '../components/ui/GridPattern';
import { DollarSignIcon, UsersIcon, ClockIcon, MapPinIcon, CalendarIcon } from 'lucide-react';
const StrategyPage = () => {
  return <div className="w-full min-h-screen bg-center bg-cover bg-no-repeat bg-gray-900" data-id="element-391">
      <div className="pt-28 sm:pt-32 md:pt-36" data-id="element-392">
        <div className="max-w-7xl mx-auto px-4 sm:px-6" data-id="element-393">
          {/* Our Purchase Model Section - Now Singular */}
          <div className="mb-16 sm:mb-24" data-id="element-394">
            <h2 className="text-3xl sm:text-4xl md:text-5xl font-light text-white text-center tracking-normal mb-8 sm:mb-12" data-id="element-395">
              Our Purchase Model
            </h2>
            <div className="max-w-3xl mx-auto" data-id="element-396">
              {/* Legacy Partnership Model */}
              <div className="relative bg-gradient-to-b from-gray-900/50 to-gray-900/30 p-4 sm:p-6 md:p-8 rounded-2xl border border-gray-700 shadow-sm overflow-hidden transition-all duration-300 hover:border-[#4ECDC4]/50 hover:shadow-[0_0_15px_rgba(78,205,196,0.15)]" data-id="element-397">
                <Grid size={20} data-id="element-398" />
                <div className="relative z-20" data-id="element-399">
                  <h3 className="text-2xl sm:text-3xl font-light text-white mb-4 sm:mb-6 tracking-normal text-center" data-id="element-400">
                    LEGACY PARTNERSHIP
                  </h3>
                  <div className="space-y-6" data-id="element-401">
                    <div data-id="element-402">
                      <h4 className="text-[#4ECDC4] text-lg font-light mb-2" data-id="element-403">
                        WHAT:
                      </h4>
                      <p className="text-gray-300 font-light" data-id="element-404">
                        A buyout or majority investment into your clinic with us
                        working alongside you as partners
                      </p>
                    </div>
                    <div data-id="element-405">
                      <h4 className="text-[#4ECDC4] text-lg font-light mb-2" data-id="element-406">
                        HOW:
                      </h4>
                      <p className="text-gray-300 font-light" data-id="element-407">
                        We invest and implement the best systems, processes, and
                        care to grow the clinic over time. You focus on the
                        patients and staff, and we focus on everything else.
                      </p>
                    </div>
                    <div data-id="element-408">
                      <h4 className="text-[#4ECDC4] text-lg font-light mb-2" data-id="element-409">
                        WHY:
                      </h4>
                      <p className="text-gray-300 font-light" data-id="element-410">
                        Builds clinical efficiencies, standardizations, value,
                        and ultimately legacy.
                      </p>
                    </div>
                    <div data-id="element-411">
                      <h4 className="text-[#4ECDC4] text-lg font-light mb-2" data-id="element-412">
                        WHEN:
                      </h4>
                      <p className="text-gray-300 font-light" data-id="element-413">
                        Purchase within 60 - 120 days
                      </p>
                    </div>
                    <div data-id="element-414">
                      <h4 className="text-[#4ECDC4] text-lg font-light mb-2" data-id="element-415">
                        REQUIRED:
                      </h4>
                      <ul className="space-y-2" data-id="element-416">
                        <li className="flex items-center gap-2 text-gray-300 font-light" data-id="element-417">
                          <DollarSignIcon className="w-5 h-5 text-[#4ECDC4]" data-id="element-418" />
                          $300k+ minimum annual revenue
                        </li>
                        <li className="flex items-center gap-2 text-gray-300 font-light" data-id="element-419">
                          <ClockIcon className="w-5 h-5 text-[#4ECDC4]" data-id="element-420" />
                          5+ years in business
                        </li>
                        <li className="flex items-center gap-2 text-gray-300 font-light" data-id="element-421">
                          <DollarSignIcon className="w-5 h-5 text-[#4ECDC4]" data-id="element-422" />
                          50%+ cash collections
                        </li>
                        <li className="flex items-center gap-2 text-gray-300 font-light" data-id="element-423">
                          <MapPinIcon className="w-5 h-5 text-[#4ECDC4]" data-id="element-424" />
                          Located in Texas or Florida
                        </li>
                      </ul>
                    </div>
                    <div data-id="element-425">
                      <h4 className="text-[#4ECDC4] text-lg font-light mb-2" data-id="element-426">
                        COMMITMENT:
                      </h4>
                      <div className="flex items-center gap-2 text-gray-300 font-light" data-id="element-427">
                        <CalendarIcon className="w-5 h-5 text-[#4ECDC4]" data-id="element-428" />
                        3-Year minimum commitment in your current role
                        post-acquisition
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* Strategy Section - Now Second */}
          <div className="mb-16 sm:mb-24" data-id="element-429">
            <h2 className="text-3xl sm:text-4xl md:text-5xl font-light text-white text-center tracking-normal mb-8 sm:mb-12" data-id="element-430">
              Our Strategy
            </h2>
            <div className="bg-gray-900/50 p-4 sm:p-6 md:p-8 rounded-2xl border border-gray-700 shadow-sm" data-id="element-431">
              <StrategicFeatures data-id="element-432" />
            </div>
          </div>
          {/* Differentiators Section - Now Third */}
          <div className="mb-16 sm:mb-24" data-id="element-433">
            <h1 className="text-3xl sm:text-4xl md:text-5xl font-light text-white mb-8 sm:mb-12 tracking-normal text-center" data-id="element-434">
              Our Differentiators
            </h1>
            <div className="bg-gray-900/50 p-4 sm:p-6 md:p-8 rounded-2xl border border-gray-700 shadow-sm" data-id="element-435">
              <div className="min-h-[600px] sm:min-h-[700px]" data-id="element-436">
                <DifferentiatorsTimeline data-id="element-437" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>;
};
export default StrategyPage;